import {Injectable} from '@angular/core'
import {Observable, of} from 'rxjs'
import {HttpClient} from '@angular/common/http'
import {Info} from './types/info';


@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(private http: HttpClient) {
  }

  pobierzInfo(): Observable<Info> {
    if (window.document.baseURI.includes('http://localhost:')){
      return of({build: {version: 'localhost'}, application: {name: 'SelfserviceUI', version: 'dev'}} as Info)
    }
    return this.http.get<Info>('/info')
  }
}
